"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _RadioSwatch = _interopRequireDefault(require("./RadioSwatch"));
var _utilities = require("@vds-core/utilities");
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var propTypes = {
  /**
   * If provided, RadioSwatch components will be rendered based on this data
   * @typeName radioSwatchData
   */
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    label: _propTypes["default"].string,
    value: _propTypes["default"].string,
    color: _propTypes["default"].string,
    outOfStock: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    "data-analyticstrack": _propTypes["default"].string,
    "data-track": _propTypes["default"].string,
    "data-track-ignore": _propTypes["default"].string,
    "data-clickstream": _propTypes["default"].string
  })),
  /**
   * @deprecated data
   */
  children: _propTypes["default"].node,
  /**
   * @deprecated
   */
  className: _propTypes["default"].string,
  /**
   * If provided, the RadioSwatch component with a corresponding value will be selected when the RadioSwatchGroup is rendered.
   */
  defaultValue: _propTypes["default"].string,
  /**
   * If provided, the Radio component with a corresponding value will be selected and the selection of the RadioSwatchGroup will be controlled.
   */
  value: _propTypes["default"].string,
  /**
   * If provided, the name of RadioSwatch component is rendered.
   */
  name: _propTypes["default"].string,
  /**
   * Optional function that is called when RadioSwatch component is selected. If provided, it will be called with a DOM form event object from selected Radio.
   */
  onChange: _propTypes["default"].func,
  /**
   * Allows a unique ID to be passed to the component.
   */
  id: _propTypes["default"].string,
  /**
   * @ignore
   */
  disabledState: _propTypes["default"].bool,
  /**
   * @ignore
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  className: null,
  defaultValue: null,
  name: null,
  onChange: function onChange() {},
  disabledState: true,
  inverted: false
};
var RadioSwatchGroupWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RadioSwatchGroupWrapper",
  componentId: "sc-1o2oytn-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));
var InputWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "InputWrapper",
  componentId: "sc-1o2oytn-1"
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-bottom: ", ";\n"])), (0, _javascriptStyleHelpers.calculateRem)(16));
var RadioSwatchGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RadioSwatchGroup, _React$Component);
  var _super = _createSuper(RadioSwatchGroup);
  function RadioSwatchGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RadioSwatchGroup);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleColorSelect", function (e) {
      _this.props.onChange(e);
      if (!_this.props.hasOwnProperty("value")) {
        _this.setState({
          selectedColor: e.target.value
        });
      }
    });
    _this.state = {
      selectedColor: _this.props.defaultValue || _this.props.value
    };
    return _this;
  }
  (0, _createClass2["default"])(RadioSwatchGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        this.setState({
          selectedColor: this.props.value
        });
      }
    }
  }, {
    key: "renderColorSelects",
    value:
    // Maintain backwards compatibility
    function renderColorSelects() {
      var _this2 = this;
      var children = this.props.children;
      return _react["default"].Children.map(children, function (child, index) {
        var isLastChild = children.length - 1 === index;
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          key: index + 1,
          selected: _this2.state.selectedColor === child.props.value,
          checked: _this2.state.selectedColor === child.props.value,
          onChange: _this2.handleColorSelect,
          lastChild: isLastChild,
          typescale: _this2.props.typescale,
          typographyConfig: _this2.props.typographyConfig,
          bodyConfig: _this2.props.bodyConfig
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        data = _this$props.data,
        bodyConfig = _this$props.bodyConfig,
        typographyConfig = _this$props.typographyConfig,
        value = _this$props.value,
        focusSize = _this$props.focusSize,
        focusState = _this$props.focusState,
        labelMargin = _this$props.labelMargin,
        labelMaxWidth = _this$props.labelMaxWidth,
        labelMinWidth = _this$props.labelMinWidth,
        swatchMargin = _this$props.swatchMargin,
        size = _this$props.size,
        selectedStateDoubleBorder = _this$props.selectedStateDoubleBorder,
        disabledState = _this$props.disabledState,
        typescale = _this$props.typescale,
        id = _this$props.id,
        inverted = _this$props.inverted;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, children && /*#__PURE__*/_react["default"].createElement(InputWrapper, {
        id: id,
        className: className
      }, this.renderColorSelects()), data && /*#__PURE__*/_react["default"].createElement(RadioSwatchGroupWrapper, (0, _extends2["default"])({}, this.props, {
        id: id,
        "data-testid": "test-color-input",
        role: "radiogroup"
      }), data.map(function (child, index) {
        var inputId = child.inputId;
        return /*#__PURE__*/_react["default"].createElement(_RadioSwatch["default"], (0, _extends2["default"])({}, child, {
          id: "swatchId".concat(index + 1),
          inputId: inputId,
          key: ++index,
          disabled: child.disabled,
          disabledState: disabledState,
          outOfStock: child.outOfStock,
          color: child.color,
          label: child.label,
          value: child.value,
          checked: _this3.state.selectedColor === child.value,
          selected: _this3.state.selectedColor === child.value,
          bodyConfig: child.bodyConfig || bodyConfig,
          typographyConfig: child.typographyConfig || typographyConfig,
          focusSize: focusSize,
          focusState: focusState,
          labelMargin: labelMargin,
          labelMaxWidth: labelMaxWidth,
          labelMinWidth: labelMinWidth,
          swatchMargin: swatchMargin,
          size: size,
          typescale: child.typescale || typescale,
          selectedStateDoubleBorder: selectedStateDoubleBorder,
          numberOfSwatches: data.length,
          onChange: _this3.handleColorSelect,
          inverted: inverted
        }));
      })));
    }
  }]);
  return RadioSwatchGroup;
}(_react["default"].Component);
RadioSwatchGroup.propTypes = propTypes;
RadioSwatchGroup.defaultProps = defaultProps;
var _default = exports["default"] = (0, _utilities.withVDSManager)(RadioSwatchGroup);


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/RadioSwatch/RadioSwatchGroup.js
// module id = 1458
// module chunks = 0